import React from 'react';
import { fmtCost, fmtInt, fmtTokens } from './format';

// Generic breakdown list: name · calls · tokens · cost with a proportional bar (feature / person / model).
export const CostBreakdownTable = ({ title, subtitle, rows, nameOf, subOf, testid, emptyText = 'Noch keine KI-Aufrufe im Zeitraum.' }) => {
  const max = Math.max(0, ...rows.map(r => r.cost || 0));
  return (
    <div className="bg-card border border-border rounded-sm p-4" data-testid={testid}>
      <p className="font-heading text-base text-foreground">{title}</p>
      {subtitle && <p className="text-[10px] text-muted-foreground mb-2">{subtitle}</p>}
      {rows.length === 0 ? <p className="text-xs text-muted-foreground mt-2">{emptyText}</p> : (
        <div className="mt-2 space-y-2">
          {rows.map((r, i) => (
            <div key={i} data-testid={`${testid}-row-${i}`}>
              <div className="flex items-center justify-between gap-2 text-xs">
                <span className="text-foreground truncate" title={nameOf(r)}>{nameOf(r)}
                  {subOf && <span className="text-muted-foreground ml-1.5 text-[10px]">{subOf(r)}</span>}
                </span>
                <span className="font-mono text-amber-400 shrink-0">{fmtCost(r.cost)}</span>
              </div>
              <div className="flex items-center gap-2 mt-0.5">
                <div className="h-1 flex-1 bg-secondary rounded-sm overflow-hidden">
                  <div className="h-full bg-amber-500/70" style={{ width: `${max > 0 ? Math.max(2, (r.cost / max) * 100) : 0}%` }} />
                </div>
                <span className="text-[10px] font-mono text-muted-foreground shrink-0">
                  {fmtInt(r.calls)} Aufrufe · {fmtTokens(r.prompt_tokens)} / {fmtTokens(r.completion_tokens)}
                  {r.errors > 0 && <span className="text-red-400"> · {r.errors} Fehler</span>}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
